import dayjs from 'dayjs';

export function extractDateBySecond(dateString, useComma = true) {
    if (!dateString) {
        return '-';
    }

    const utcDate = new Date(dateString);

    if (isNaN(utcDate.getTime())) {
        return '-';
    }

    const tashkentDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60 * 1000 + 5 * 60 * 60 * 1000);

    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    };

    const formatted = tashkentDate.toLocaleString('en-GB', options);

    return useComma ? formatted : formatted.replace(',', '');
}

export const defaultExtractDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
};

export const extractStringDate = (dateString) => {
    const date = new Date(dateString);

    const options = {year: 'numeric', month: 'short', day: 'numeric'};
    const formattedDate = date.toLocaleDateString('en-US', options);

    const [month, day, year] = formattedDate.split(' ');
    const monthAbbr = month.slice(0, 3) + '.';

    return `${monthAbbr} ${day} ${year}`;
};

export const extractStringDateBySecond = (dateString) => {
    const date = new Date(dateString);

    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false // Optional: for 24-hour format change to true
    };

    const formattedDate = date.toLocaleString('en-US', options);
    const [month, day, year, hours, minutes, seconds] = formattedDate.split(/[\s,:-]+/);
    const monthAbbr = month.slice(0, 3) + '.';

    return `${monthAbbr} ${day} ${year} ${hours}:${minutes}:${seconds}`;
};


export const getFormattedPeriod = (startDate, endDate) => {
    const start = dayjs(startDate).startOf('day');
    const end = dayjs(endDate)
        .set('hour', 23)
        .set('minute', 59)
        .set('second', 59)
        .set('millisecond', 999);

    return {
        startPeriod: start.format('YYYY-MM-DD HH:mm:ss'),
        endPeriod: end.format('YYYY-MM-DD HH:mm:ss'),
    };
};

/**
 * Format a date string into a custom short format without the year.
 *
 * Example:
 *   Input:  "2025-08-22T14:35:42Z"
 *   Output: "Aug. 22, 14:35:42"
 */
export const extractStringDateWithSeconds = (dateString) => {
    const date = new Date(dateString);

    const options = {month: 'short', day: 'numeric'};
    const formattedDate = date.toLocaleDateString('en-US', options);

    const [month, day] = formattedDate.split(' ');
    const monthAbbr = month.slice(0, 3) + '.';

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${monthAbbr} ${day}, ${hours}:${minutes}:${seconds}`;
};


export function subtractDates(date1, date2) {
    const oneSecond = 1000; // milliseconds in one day
    const diffInMilliseconds = date1.getTime() - date2.getTime();
    return Math.round(diffInMilliseconds / oneSecond); // Convert milliseconds to days
}